import React, {Suspense} from 'react'
import {Route, Switch} from 'react-router-dom'

import PageLoader from '@progyny/components/PageLoader'
import {RouteEnum, useRoutes} from '@progyny/routes'

const KnowledgeCenterHome = React.lazy(
  () => import('@progyny/pages/KnowledgeCenter/Home')
)
const ArticleSegment = React.lazy(
  () => import('@progyny/pages/KnowledgeCenter/ArticleSegment')
)
const SearchResults = React.lazy(
  () => import('@progyny/pages/KnowledgeCenter/Search/results')
)

const KnowledgeCenterRoutes = () => {
  const {getPath} = useRoutes()
  return (
    <Suspense fallback={<PageLoader position={'top'} />}>
      <Switch>
        <Route
          exact
          path={getPath(RouteEnum.KNOWLEDGE_CENTER)}
          component={KnowledgeCenterHome}
        />
        <Route
          exact
          path={`${getPath(RouteEnum.KNOWLEDGE_CENTER)}/search/results`}
          component={SearchResults}
        />
        <Route
          path={`${getPath(RouteEnum.KNOWLEDGE_CENTER)}/:slug`}
          component={ArticleSegment}
        />
      </Switch>
    </Suspense>
  )
}

export default KnowledgeCenterRoutes
